import {UIState} from "data/UIState";

declare var $:any;

import * as React from 'react';
import { observer } from 'mobx-react';
import {action, computed, observable} from 'mobx';
import { PUT_QUERY } from 'utils';
import { FeedItemQuiz } from './FeedItemQuiz';
import { FeedItemComplex } from './FeedItemComplex';

import './FeedItem.pcss';
import {CodewordLock} from "components/feed/FeedItem/CodewordLock";
import {StringHelpers} from "shared/StringHelpers";

interface IFeedItemProps {
	feedItem:any;
	user:any;
	updateFeedItem:(feedItem:any)=>void;
	openFullPostModal:(feedItem:any)=>void;
}

/**
 * used:
 * home.tsx/_HomePage
 */
@observer
export class FeedItem extends React.Component<IFeedItemProps, {}> {
	@observable feedItem:any;

	constructor(props) {
		super(props);
		this.feedItem = this.props.feedItem;
	}

	updateFeedItem = (feedItem) => {
		this.feedItem = feedItem;
		this.props.updateFeedItem(feedItem);
	}

	openFullPostModal = () => {
		this.props.openFullPostModal(this.feedItem);
	}

	handleClick = () => {
		// if not read, mark it read...		
		if(false==this.props.feedItem.read) {				
			let markRead = true;
			if(this.props.feedItem._post){
				const fp = StringHelpers.safeHTML(this.props.feedItem._post.fullPost);
				if(fp!=null) {
					markRead = false;
				}
			}

			if(this.props.feedItem._post) {
				if(this.props.feedItem._post.type=='quiz' || this.props.feedItem._post.bottomLinkAction){
					markRead = false;
				}
			}

			if(markRead){
				// TODO: updateFeedItem should make the changes on the server	
				$.ajax(PUT_QUERY('/feed/items/'+this.props.feedItem._id,{read:true}))
				.done(() => {
					const feedItem = this.props.feedItem;
					feedItem.read = true;
					this.updateFeedItem(feedItem);
				})
				.fail();
			}
		}		
	}


	render(){
		if(this.feedItem.type==='post' || this.feedItem.type==='checkin' || this.feedItem.type==='points' ){
			return (
				<article onClick={this.handleClick} className={"feedItem"}>

					<CodewordLock feedItem={this.feedItem} onSuccessFullUnlock={this.updateFeedItem} />

					{(this.feedItem._post && this.feedItem._post.type==='quiz') ?
						<FeedItemQuiz feedItem={this.feedItem} updateFeedItem={this.updateFeedItem} />
					:
						<FeedItemComplex user={this.props.user} feedItem={this.feedItem} openFullPostModal={this.openFullPostModal} updateFeedItem={this.updateFeedItem} />
					}
				</article>
			);
		} else if(this.feedItem.type!=='attendance_points'){
			return <h2 className="date-context-title">{this.feedItem.content}</h2>;
		} else {
			return null;
		}
	}
}

